import { bool, func, string } from "prop-types";
import * as React from "react";

import { isPresent } from "Services/helper-utils";
import { EMPTY_ARR } from "Services/constants/empty";
import Styles from "./styles.css";

class InputTag extends React.Component {
	tagIdRegex = new RegExp(/^[a-zA-Z]{3,5}-[0-9]{1}$/);
	static propTypes = {
		isDisabled: bool,
		isRequired: bool,
		isValid: bool,
		label: string,
		name: string,
		onChange: func,
		value: string,
	};
	constructor(props) {
		super(props);
		this.state = {
			errors: this.validate(props.value, props.isRequired),
			isTouched: false,
		};
	}
	validate = (value, isRequired) => {
		if (isRequired && !isPresent(value)) {
			return ["Required"];
		} else if (!this.tagIdRegex.test(value)) {
			return ["Invalid Tag ID"];
		}
		return EMPTY_ARR;
	};
	transformTagValue = (fieldValue) => {
		let formatted = fieldValue.toUpperCase().replace(/[^A-Z0-9]/g, "");
		if (formatted.length > 3) {
			if (formatted.length > 5) {
				formatted = formatted.replace(/(.{5})/g, "$1-"); // add hyphen every 5th character
				formatted = formatted.slice(0, 7); // remove any characters after the 7th
			} else if (formatted.length > 4) {
			} else {
				formatted = formatted.replace(/(.{3})/g, "$1-"); // add hyphen every 3rd character
			}
		}
		return formatted.replace(/-+/, "-");
	};
	handleOnChange = (e) => {
		const { isDisabled, isRequired, name, onChange } = this.props;
		if (isDisabled) return;
		const value = this.transformTagValue(e.target.value);
		const errors = this.validate(value, isRequired);
		this.setState({
			errors,
		});
		onChange(name, value, errors.length === 0);
	};
	handleOnBlur = () => {
		if (!this.state.isTouched) {
			this.setState({
				isTouched: true,
			});
		}
	};
	render() {
		const { isDisabled, isRequired, label, name, value } = this.props;
		const { errors, isTouched } = this.state;
		return (
			<div css={Styles.wrapper(isDisabled)}>
				{isDisabled && <div css={Styles.inputCover} />}
				<input
					css={Styles.input(errors.length > 0, isTouched)}
					disabled={isDisabled}
					name={name}
					onBlur={this.handleOnBlur}
					onChange={this.handleOnChange}
					placeholder={isRequired ? `*${label}` : label}
					required={isRequired}
					tabIndex={1}
					type="text"
					value={value}
				/>
				{errors.length > 0 && (
					<div css={Styles.error(isTouched)}>{errors[0]}</div>
				)}
			</div>
		);
	}
}

export default InputTag;
